<template>
    <div>
        <b-row>
            <b-col cols="9">
                <b-row>
                    <b-col class="workspace-header">
                        <h1 class="text-right"><i class="fa-solid fa-file-contract"></i> Compliance Flags</h1>
                    </b-col>
                </b-row>
                <b-card>
                    <span class="text-muted font-weight-light">PFA</span>
                    <b-card>
                        <b-row>
                            <b-col v-for="button in sortedButtonTypes.pfa" cols="3">
                                <b-button block variant="primary" class="mb-2" :to="button.url">{{ button.name }}</b-button>
                            </b-col>
                        </b-row>
                    </b-card>
                    <span class="text-muted font-weight-light">Misc</span>
                    <b-card>
                        <b-row>
                            <b-col v-for="button in sortedButtonTypes.other" cols="3">
                                <b-button block variant="primary" class="mb-2" :to="button.url">{{ button.name }}</b-button>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-card>
            </b-col>

            <b-col cols="3">

            </b-col>
        </b-row>
    </div>
</template>

<script>
    export default {
        name: "flags-compliance",
        computed: {
            sortedButtonTypes() {
                let pfa = this.buttons.filter(a => a.type == 'pfa')
                let other = this.buttons.filter(a => a.type == 'other')
                return {
                    pfa: pfa,
                    other: other,
                }
            }
        },

        data() {
           return {
               buttons : [
                {
                    name: 'PFA - Other',
                    url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=22',
                    type: 'pfa'
                },
                {
                    name: 'PFA - # of Transactions',
                    url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=43&filterField_1=status_id&filterModel_1=order&filterName_1=Order%20Status&filterParameter_1=not%20equal%20to&filterValue_1=12',
                    type: 'pfa'
                },
                {
                    name: 'PFA - Dup Phone',
                    url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=41&filterField_1=status_id&filterModel_1=order&filterName_1=Order%20Status&filterParameter_1=not%20equal%20to&filterValue_1=12',
                    type: 'pfa'
                },
                {
                    name: 'PFA - Dup ID',
                    url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=40&filterField_1=status_id&filterModel_1=order&filterName_1=Order%20Status&filterParameter_1=not%20equal%20to&filterValue_1=12',
                    type: 'pfa'
                },
                {
                    name: 'PFA - Dup Banking',
                    url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=42&filterField_1=status_id&filterModel_1=order&filterName_1=Order%20Status&filterParameter_1=not%20equal%20to&filterValue_1=12',
                    type: 'pfa'
                },
                {
                    name: 'PFA - Multiple Same Item',
                    url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=50&filterField_1=status_id&filterModel_1=order&filterName_1=Order%20Status&filterParameter_1=not%20equal%20to&filterValue_1=12',
                    type: 'pfa'
                },
                {
                    name: 'PFA - Tags',
                    url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=38&filterField_1=status_id&filterModel_1=order&filterName_1=Order%20Status&filterParameter_1=not%20equal%20to&filterValue_1=12',
                    type: 'pfa'
                },
                {
                    name: 'PFA - Weight',
                    url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=48&filterField_1=status_id&filterModel_1=order&filterName_1=Order%20Status&filterParameter_1=not%20equal%20to&filterValue_1=12',
                    type: 'pfa'
                },
                {
                    name: 'PFA - Quantity',
                    url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=45&filterField_1=status_id&filterModel_1=order&filterName_1=Order%20Status&filterParameter_1=not%20equal%20to&filterValue_1=12',
                    type: 'pfa'
                },
                {
                    name: 'PFA - Engraving',
                    url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=44&filterField_1=status_id&filterModel_1=order&filterName_1=Order%20Status&filterParameter_1=not%20equal%20to&filterValue_1=12',
                    type: 'pfa'
                },
                {
                    name: 'PFA - Serial Number',
                    url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=39&filterField_1=status_id&filterModel_1=order&filterName_1=Order%20Status&filterParameter_1=not%20equal%20to&filterValue_1=12',
                    type: 'pfa'
                },
                {
                    name: 'PFA - Altered Melted',
                    url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=47&filterField_1=status_id&filterModel_1=order&filterName_1=Order%20Status&filterParameter_1=not%20equal%20to&filterValue_1=12',
                    type: 'pfa'
                },
                {
                    name: 'PFA - Altered Cut',
                    url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=46&filterField_1=status_id&filterModel_1=order&filterName_1=Order%20Status&filterParameter_1=not%20equal%20to&filterValue_1=12',
                    type: 'pfa'
                },
                {
                    name: 'Missing Information',
                    url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=3',
                    type: 'other',
                },
                {
                    name: 'Claim - Outbound',
                    url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=20',
                    type: 'other',
                },
                {
                    name: 'Claim - Inbound',
                    url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=21',
                    type: 'other',
                },
                {
                    name: 'Release of Claims',
                    url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=51',
                    type: 'other',
                },
                {
                    name: 'On-hold OFAC',
                    url: '/search?filterField_0=flag_type_id&filterModel_0=customer_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=23',
                    type: 'other',
                },
                {
                    name: 'Anti Money Laundering',
                    url: '/search?filterField_0=flag_type_id&filterModel_0=customer_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=17&filterField_1=status_id&filterModel_1=order&filterName_1=Order%20Status&filterParameter_1=equals&filterValue_1=9',
                    type: 'other',
                },
                {
                    name: 'Additional Insurance ',
                    url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=28&filterField_1=status_id&filterModel_1=order&filterName_1=Order%20Status&filterParameter_1=not%20equal%20to&filterValue_1=12&filterField_2=status_id&filterModel_2=order&filterName_2=Order%20Status&filterParameter_2=not%20equal%20to&filterValue_2=13&filterField_3=status_id&filterModel_3=order&filterName_3=Order%20Status&filterParameter_3=not%20equal%20to&filterValue_3=15&filterField_4=status_id&filterModel_4=order&filterName_4=Order%20Status&filterParameter_4=not%20equal%20to&filterValue_4=14',
                    type: 'other',
                },
            ]};
        }
    }
</script>

<style scoped>

</style>